var _path, _path2, _g, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeeReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 74,
    viewBox: "0 0 72 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.9823 49.993C61.9967 66.7402 43.3889 76.1218 27.2521 73.5912C24.6262 73.1794 17.4277 71.9528 11.0542 66.1657C-1.21503 55.0251 -3.83905 32.9654 6.05826 17.4193C13.2618 6.1045 26.1745 -0.309274 38.4443 0.0114828C41.0871 0.0806602 51.2159 0.506533 60.1174 7.97986C61.4248 9.07751 64.3086 11.686 66.9074 15.8239C73.01 25.5409 73.535 39.0786 68.9823 49.993Z",
    fill: "#0095DF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1529_1918)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1529_1918",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 19,
    width: 37,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.0001H53.9999V56H17V19.0001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1529_1918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3888 31.3027H25.6113",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8212 37.1484H32.252",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3886 34.4834H32.25",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8212 44.0107H32.252",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3886 41.3477H32.25",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8212 50.876H32.252",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3886 48.2129H32.25",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9432 34.1011H28.7106C28.8928 34.1011 29.0424 34.2506 29.0424 34.4329V37.2004C29.0424 37.3827 28.8928 37.5322 28.7106 37.5322H25.9432C25.7609 37.5322 25.6113 37.3827 25.6113 37.2004V34.4329C25.6113 34.2506 25.7609 34.1011 25.9432 34.1011Z",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9432 40.9653H28.7106C28.8928 40.9653 29.0424 41.1148 29.0424 41.2972V44.0646C29.0424 44.247 28.8928 44.3965 28.7106 44.3965H25.9432C25.7609 44.3965 25.6113 44.247 25.6113 44.0646V41.2972C25.6113 41.1148 25.7609 40.9653 25.9432 40.9653Z",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9432 47.8275H28.7106C28.8928 47.8275 29.0424 47.9791 29.0424 48.1614V50.9268C29.0424 51.1112 28.8928 51.2607 28.7106 51.2607H25.9432C25.7609 51.2607 25.6113 51.1112 25.6113 50.9268V48.1614C25.6113 47.9791 25.7609 47.8275 25.9432 47.8275Z",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2672 38.7076V54.5915C49.2672 55.0688 48.876 55.458 48.3986 55.458H22.6008C22.1236 55.458 21.7344 55.0688 21.7344 54.5915V38.7076M21.7344 36.2064V20.4086C21.7344 19.9312 22.1236 19.5421 22.6008 19.5421H48.3986C48.876 19.5421 49.2672 19.9312 49.2672 20.4086V36.2064",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28.8923V22H32.1608V22.7404H28.8403V25.0692H31.8491V25.8096H28.8403V28.8923H28Z",
    fill: "#0095DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2916 29C34.7902 29 34.3576 28.8901 33.9939 28.6702C33.6325 28.4481 33.3535 28.1385 33.157 27.7413C32.9627 27.342 32.8656 26.8776 32.8656 26.3481C32.8656 25.8186 32.9627 25.3519 33.157 24.9481C33.3535 24.542 33.6268 24.2256 33.977 23.999C34.3293 23.7702 34.7405 23.6558 35.2103 23.6558C35.4814 23.6558 35.749 23.7006 36.0133 23.7904C36.2776 23.8801 36.5182 24.026 36.735 24.2279C36.9519 24.4276 37.1247 24.6923 37.2534 25.0221C37.3822 25.3519 37.4466 25.758 37.4466 26.2404V26.5769H33.4348V25.8904H36.6334C36.6334 25.5987 36.5747 25.3385 36.4572 25.1096C36.342 24.8808 36.1771 24.7002 35.9625 24.5678C35.7502 24.4354 35.4994 24.3692 35.2103 24.3692C34.8918 24.3692 34.6162 24.4478 34.3836 24.6048C34.1532 24.7596 33.9758 24.9615 33.8516 25.2106C33.7274 25.4596 33.6652 25.7266 33.6652 26.0115V26.4692C33.6652 26.8596 33.733 27.1905 33.8685 27.462C34.0063 27.7312 34.1972 27.9365 34.4412 28.0779C34.6851 28.217 34.9686 28.2865 35.2916 28.2865C35.5017 28.2865 35.6914 28.2574 35.8609 28.199C36.0325 28.1385 36.1805 28.0487 36.3047 27.9298C36.429 27.8087 36.525 27.6583 36.5927 27.4788L37.3653 27.6942C37.2839 27.9545 37.1473 28.1833 36.9553 28.3808C36.7633 28.576 36.5261 28.7285 36.2437 28.8385C35.9614 28.9462 35.644 29 35.2916 29Z",
    fill: "#0095DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.845 29C40.3436 29 39.911 28.8901 39.5473 28.6702C39.1859 28.4481 38.9069 28.1385 38.7104 27.7413C38.5162 27.342 38.419 26.8776 38.419 26.3481C38.419 25.8186 38.5162 25.3519 38.7104 24.9481C38.9069 24.542 39.1803 24.2256 39.5304 23.999C39.8828 23.7702 40.2939 23.6558 40.7637 23.6558C41.0348 23.6558 41.3025 23.7006 41.5667 23.7904C41.831 23.8801 42.0716 24.026 42.2885 24.2279C42.5053 24.4276 42.6781 24.6923 42.8069 25.0221C42.9356 25.3519 43 25.758 43 26.2404V26.5769H38.9883V25.8904H42.1868C42.1868 25.5987 42.1281 25.3385 42.0106 25.1096C41.8954 24.8808 41.7305 24.7002 41.5159 24.5678C41.3036 24.4354 41.0529 24.3692 40.7637 24.3692C40.4452 24.3692 40.1696 24.4478 39.937 24.6048C39.7066 24.7596 39.5293 24.9615 39.405 25.2106C39.2808 25.4596 39.2187 25.7266 39.2187 26.0115V26.4692C39.2187 26.8596 39.2864 27.1905 39.422 27.462C39.5597 27.7312 39.7506 27.9365 39.9946 28.0779C40.2385 28.217 40.522 28.2865 40.845 28.2865C41.0551 28.2865 41.2449 28.2574 41.4143 28.199C41.5859 28.1385 41.7339 28.0487 41.8581 27.9298C41.9824 27.8087 42.0784 27.6583 42.1461 27.4788L42.9187 27.6942C42.8374 27.9545 42.7007 28.1833 42.5087 28.3808C42.3167 28.576 42.0795 28.7285 41.7972 28.8385C41.5148 28.9462 41.1974 29 40.845 29Z",
    fill: "#0095DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1529_1918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(17 19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeReport);
export default __webpack_public_path__ + "static/media/fee_report.162aa75bb582d005032ce02dfd6e1f7c.svg";
export { ForwardRef as ReactComponent };